import ArticleLayout from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

export default function OttimizzazioneOrdiniPage() {
  return <ArticleLayout data={allArticles['ottimizzazione-ordini']} />;
}